import React from 'react';
import { centsToDecimal, useApplicationState } from '@apollo/core';
import ProgressBar from './ProgressBar';
import { getCurrencySymbol } from '../../../../../core/utils';

const BonusTurnoverTracker = ({ eligibilityStats, topLabelProgressBar = false }) => {
  const { eligibleTurnover = 0, requiredTurnover = 0 } = eligibilityStats;
  const required = requiredTurnover;
  const current = Math.min(eligibleTurnover, required);

  const {
    account: { currency },
  } = useApplicationState();

  if (!required) {
    return null;
  }

  return (
    <div className='bonus-eligibility-limit bonus-eligibility-limit--turnover'>
      <ProgressBar
        current={centsToDecimal(current)}
        required={centsToDecimal(required)}
        valueLabel={getCurrencySymbol(currency)}
        tooltip={`${centsToDecimal(current)} out of ${centsToDecimal(required)}`}
        title='bonus turnover'
        topLabel={topLabelProgressBar}
      />
    </div>
  );
};

export default React.memo(BonusTurnoverTracker);
